/**
 * serialize/ — тонкая обёртка над JSON (tech/25 §1).
 *
 * По контракту `GameState` — чистый JSON: без Map/Set/Date/функций/
 * undefined-в-массивах/BigInt/циклов. Поэтому сериализация — буквально
 * JSON.stringify/JSON.parse без потерь; ничего умнее здесь быть не должно.
 */
import { CURRENT_STATE_VERSION } from '../state/types.js';
export function serialize(state) {
    return JSON.stringify(state);
}
export function deserialize(json) {
    const parsed = JSON.parse(json);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        throw new Error('deserialize: ожидался JSON-объект GameState');
    }
    // Цепочек миграций в MVP нет (tech/25 §4, R17) — несовпадение версии схемы
    // отклоняем сразу, а не молча принимаем чужую форму (D24: единая ось version).
    const version = parsed.version;
    if (version !== CURRENT_STATE_VERSION) {
        throw new Error(`deserialize: версия схемы ${String(version)} не поддерживается (ожидалась ${CURRENT_STATE_VERSION}; миграции — пост-MVP, tech/25 §4)`);
    }
    return parsed;
}
//# sourceMappingURL=serialize.js.map